import { Routes } from '@angular/router';
import { authGuard } from '../auth/guards/auth.guard';

export const userRoutes: Routes = [
  {
    path: 'home',
    loadComponent: () => import('./pages/home/home.component').then((m) => m.HomeComponent),
    canMatch: [authGuard],
  },
  {
    path: 'contacts',
    loadComponent: () =>
      import('./pages/contacts/contacts.component').then((m) => m.ContactsComponent),
    canMatch: [authGuard],
  },
  {
    path: 'profile',
    loadComponent: () =>
      import('./pages/profile/profile.component').then((m) => m.ProfileComponent),
    canMatch: [authGuard],
  },
];
